// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes liveBlink {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.live-blink-badge {
    animation: liveBlink 3s infinite ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/surveillance.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,4CAA4C;AAChD","sourcesContent":["@keyframes liveBlink {\n    0% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.5;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n.live-blink-badge {\n    animation: liveBlink 3s infinite ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
